"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Functions = require("../../core/Functions");

var _decorators = require("../../utils/propTypes/decorators");

var _UIAbstractDropdown = _interopRequireDefault(require("./UIAbstractDropdown"));

var _colors = require("HubStyleTokens/colors");

// Keeps track of the effective placement and sets arrowColor accordingly
var _default = _react.default.createClass({
  displayName: "UIAbstractDropdownWithSearchbox",
  propTypes: (0, _extends2.default)({}, _UIAbstractDropdown.default.propTypes, {
    arrowColor: (0, _decorators.hidden)(_UIAbstractDropdown.default.propTypes.arrowColor),
    hasSearchbox: _propTypes.default.bool.isRequired
  }),
  getDefaultProps: function getDefaultProps() {
    return _UIAbstractDropdown.default.defaultProps;
  },
  getInitialState: function getInitialState() {
    return {
      placement: null
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    // If the placement prop is reset, clear our internal override.
    if (nextProps.placement !== this.props.placement) {
      this.setState({
        placement: null
      });
    }

    if (nextProps.open && !this.props.open) {
      this.setState({
        placement: null
      });
    }
  },
  handleChangePlacement: function handleChangePlacement(evt) {
    var onChangePlacement = this.props.onChangePlacement;
    var newPlacement = evt.newPlacement;

    if (this.state.placement !== newPlacement) {
      this.setState({
        placement: newPlacement
      });
    }

    (0, _Functions.callIfPossible)(onChangePlacement, evt);
  },
  reposition: function reposition() {
    if (this._popoverRef) {
      this._popoverRef.reposition();
    }
  },
  popoverRefCallback: function popoverRefCallback(ref) {
    this._popoverRef = ref;
  },
  render: function render() {
    var _this$props = this.props,
        buttonUse = _this$props.buttonUse,
        dropdownClassName = _this$props.dropdownClassName,
        hasSearchbox = _this$props.hasSearchbox,
        placement = _this$props.placement,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["buttonUse", "dropdownClassName", "hasSearchbox", "placement"]);
    var placementState = this.state.placement;
    var defaultPlacement = buttonUse.match(/link|transparent/) ? 'bottom' : 'bottom right';
    var computedPlacement = placementState || placement || defaultPlacement;
    var arrowAtBottom = computedPlacement.includes('bottom');
    var arrowAtTop = computedPlacement.includes('top');
    var computedArrowColor = hasSearchbox && arrowAtBottom ? _colors.KOALA : null;
    var computedDropdownClassName = (0, _classnames.default)(dropdownClassName, {
      'p-y-0': hasSearchbox && arrowAtBottom,
      'p-top-0': hasSearchbox && arrowAtTop
    });
    return _react.default.createElement(_UIAbstractDropdown.default, (0, _extends2.default)({}, rest, {
      arrowColor: computedArrowColor,
      buttonUse: buttonUse,
      dropdownClassName: computedDropdownClassName,
      onChangePlacement: this.handleChangePlacement,
      placement: computedPlacement,
      ref: this.popoverRefCallback
    }));
  }
});

exports.default = _default;
module.exports = exports.default;